var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grow flex-wrap",attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"type":"line","height":_vm.height,"width":_vm.width,"options":_vm.line.chartOptions,"series":_vm.line.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }